import * as ActionTypes from '../constants';
import axios from 'axios'; 
import { baseUrl } from '../index'; 

export default function (state = {}, action) {

    switch(action.type){
        case ActionTypes.REQUEST_USER_NAME_VERIFY:
        return {
            ...state,
            loading:true,
            error:false,
            errorInfo:null,
            response: null
        }

        case ActionTypes.RECEIVED_USER_NAME_VERIFY:
        return {
            ...state,
            loading:false,
            response:action.res,
            error:false,
            errorInfo:null
        }

        case ActionTypes.ERROR_USER_NAME_VERIFY:
        return {
            ...state,
            loading:false,
            error:true,
            errorInfo:action.err,
            response: null
        }

        case ActionTypes.CLEAR_USER_NAME_VERIFY:
        return {}
        default: return state;
    }

}





const dispatchRequestUserNameVerify = userNameVerify => ({
        type:ActionTypes.REQUEST_USER_NAME_VERIFY,
        userNameVerify
})

const dispatchReceivedUserNameVerify = res =>({
    type:ActionTypes.RECEIVED_USER_NAME_VERIFY,
    res
})

const dispatchErrorUserNameVerify = (err) => ({
    type:ActionTypes.ERROR_USER_NAME_VERIFY,
    err
})

const dispatchClearUserNameVerify = () => ({
    type: ActionTypes.CLEAR_USER_NAME_VERIFY
})

export const clearUserNameVerify = () => dispatchClearUserNameVerify();

export const userNameVerify = (userName) => dispatch => {

    dispatch(dispatchRequestUserNameVerify(userName));

            const options = {
                method: 'post',
                url: `${baseUrl}/api/verify_username`,
                data: {
                    username: userName
                }
            }
            axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedUserNameVerify(data))
                })
                .catch(e => dispatch(dispatchErrorUserNameVerify(e)));    
                
}